/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

import { requestText, type RequestError } from "@/utils/request";
import type { ResultAsync } from "@/utils/result";

export type UpdateCartResponse = string;

export type UpdateCartError = RequestError;

let controller: AbortController;

export function updateCart(data: BodyInit): ResultAsync<UpdateCartResponse, UpdateCartError>;
export function updateCart(url: string | null, data: BodyInit, headers?: HeadersInit): ResultAsync<UpdateCartResponse, UpdateCartError>;
export function updateCart(url: string | BodyInit | null, data?: BodyInit, headers?: HeadersInit) {
    if (!data) {
        data = url as BodyInit;
        url = null;
    }
    if (typeof url !== 'string') {
        url = window.themeConfig.urls.cart.update;
    }

    controller?.abort();
    controller = new AbortController();

    return requestText(url, {
        method: 'POST',
        body: data,
        headers,
        signal: controller.signal
    });
}
